import React, { } from "react";
import { Field } from "@progress/kendo-react-form";
import {
  FormInput,
  FormComboBox,
  FormNumericTextBox
} from "../core/customComponents";
import {
  cardValidator,
  crditAbleValidator,
  cradNAccountNumber,
  acntNameValidator,
  AmountValidator,
  TransferFromValidator,
  priceValidator,
  TransferToValidator,
  cardValidator1,
} from "../core/validationRules";
import configData from "../appconfig/config.json";
import {BANK_NAMES} from "../data/banklist";

import {PRICE_KEYS} from "../data/pricingNew.js";

import helper from '../data/Helper';


const banklist = BANK_NAMES;
let responsesetitesms;
let checkCAAcntFlag;
let checkCCAcntFlag;



const acntType = [configData.CCACNTNo, configData.CRACNTNo];

let spceobj = '  '
const handleSelect = async (event) => {


  if (event.target.value === "CreditAble Account") {
    configData.checkCAAcntFlag = true;
    configData.checkCCAcntFlag = false;
  }
  if (event.target.value !== "CreditAble Account") {
    configData.checkCAAcntFlag = false;
    configData.checkCCAcntFlag = true;
  }
};



const FundTransferList = (props) => {
  return props.FundTransferDetails.map((val, idx) => {
    if (idx >= 4) {
      configData.AddActiontohide = false;
    }

    let transferFrom = `transferFrom`,
      CreditAcntNO = `CreditAcntNO`,
      CreditAbleAcntNO = `CreditAbleAcntNO`,
      pricing = `pricing`,
      transferto = `transferto`,
      Nameancnt = `Nameancnt`,
      CreditCardnumber = `CreditCardnumber`,
      Amount = `Amount`;

    return (
      <div key={val.index}>

        <br></br>
        <Field
          key={"transferFrom"}
          id={transferFrom}
          name={transferFrom}
          className="form-control required"
          label={"Transfer From"}
          component={FormComboBox}
          data={acntType}
          validator={TransferFromValidator}
          onChange={handleSelect}
        />

        {configData.checkCCAcntFlag && (          
          <Field
            key={"CreditAcntNO"}
            className="form-control required"
            id={CreditAcntNO}
            name={CreditAcntNO}
            label={"Credit Card Account Number"}
            placeholder={"16 digit Credit Card Account Number"}
            component={FormInput}
            maxLength={16}
            validator={cardValidator1}
          />
        )}

        {configData.checkCAAcntFlag && (
          <Field
            id={"CreditAbleAcntNO"}
            key={"CreditAbleAcntNO"}
            name={CreditAbleAcntNO}
            className="form-control required"
            label={"CreditAble Account Number"}
            placeholder={"11 digit CreditAble Account Number"}
            component={FormInput}
            maxLength={11}
            validator={crditAbleValidator}
          />
        )}

        <Field
          key={"pricing"}
          id={pricing}
          name={pricing}
          label={"Pricing"}
          component={FormComboBox}
          data={(localStorage.getItem('p') === configData.SRC_CODE_HNW) ? [PRICE_KEYS.ratesHNW] : (localStorage.getItem('p') === configData.SRC_CODE_CCFT03) ? [PRICE_KEYS.rates810203] : (localStorage.getItem('p') === configData.SRC_CODE_CCFT04)? [PRICE_KEYS.rates810204] : (localStorage.getItem('p') === configData.SRC_CODE_CCFT || localStorage.getItem('p') === configData.SRC_CODE_CCFT04 || localStorage.getItem('p') === configData.SRC_CODE_CCFT05 || localStorage.getItem('p') === configData.SRC_CODE_CCFT06) ? PRICE_KEYS.ratesDefault : (localStorage.getItem('p') === configData.SRC_CODE_OUTSIDERS) ? [PRICE_KEYS.ratesMbnkOuters] : PRICE_KEYS.ratesDefault}
          hint={
            "Offer is subject to good account conduct, otherwise prevailing interest rate applies."
          }
          validator={priceValidator}
          className="form-control required"
        />
        <Field
          key={"transferto"}
          id={transferto}
          name={transferto}
          label={"Transfer To"}
          component={FormComboBox}
          data={banklist}
          validator={TransferToValidator}
          className="form-control required"
        />
        <Field
          id={Nameancnt}
          className="form-control required"
          name={Nameancnt}
          label={"Name of Account Holder"}
          placeholder={"Name of Account Holder"}
          component={FormInput}
          validator={acntNameValidator}
        />
        <Field
          id={CreditCardnumber}
          className="form-control required"
          name={CreditCardnumber}
          label={"Credit Card / Account Number"}
          placeholder={"Credit Card / Account Number"}
          component={FormInput}
          validator={cradNAccountNumber}
        />
        <Field
          id={Amount}
          className="form-control required"
          name={Amount}
          label={"Amount"}
          placeholder={"Fund Transfer Amount"}
          component={FormNumericTextBox}
          min={0}
          validator={AmountValidator} />

        <div className="row around-xs inputPair elementVisible" >
          <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
            <div className="box">
            </div>
          </div>
          <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8">
            <p style={{
              marginTop: "0px",
              display: "-webkit-flex",
              display: "flex",
              fontSize: "12px",
              fontStyle: "italic",
            }}>
              Note: Minumum {helper.displayAmtNote()} round down to the nearest hundred. Maximum approved loan amount will be at 95% of available credit limit during time of processing.</p><p style={{
                marginTop: "0px",
                display: "-webkit-flex",
                display: "flex",
                fontSize: "12px",
                fontStyle: "italic",
              }}>For example, if your available credit limit is $6,000 then the maximum Fund Transfer amount is $5,700.</p>
          </div>
        </div>

        <br></br>

      </div>
    );
  });
};
export default FundTransferList;
